"use client";

import { useEffect } from "react";
import { Capacitor } from "@capacitor/core";

/**
 * Tag <html> with data-capacitor="native" (and data-platform) when the
 * page runs inside Capacitor's WKWebView/WebView. CSS gates native-only
 * tweaks (e.g. disabling iOS rubber-band scrolling, hiding browser-only
 * UI) behind this attribute so mobile Safari and desktop keep their
 * stock behavior.
 */
export function CapacitorEnvironment() {
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;
    const root = document.documentElement;
    const platform = Capacitor.getPlatform();
    root.dataset.capacitor = "native";
    root.dataset.platform = platform;
    return () => {
      delete root.dataset.capacitor;
      delete root.dataset.platform;
    };
  }, []);
  return null;
}
